import {Component, input, model} from '@angular/core';
import {FermetureJourSemainePlanProdErreurDTO} from '../../../core/dtos/client/fermeture/fermeture-jour-semaine-plan-prod-erreur-dto';

@Component({
  selector: 'yo-fermeture-erreur-jour',
  templateUrl: './fermeture-erreur-jour.component.html',
  standalone: false
})
export class FermetureErreurJourComponent {

  visible = model(false);
  erreurs = input<FermetureJourSemainePlanProdErreurDTO[]>([]);
}
